import { createFileRoute } from '@tanstack/react-router';
import { CourseManagementPage } from '@/pages/chain/courses/CourseManagementPage';
import { z } from 'zod';

const searchSchema = z.object({
	tab: z.enum(['details', 'materials', 'enrollments']).optional(),
	enrollmentStatus: z.enum(['ENROLLED', 'COMPLETED', 'CANCELLED', 'NO_SHOW']).optional(),
	enrollmentPage: z.number().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/chain/courses/$courseId/manage')({
	validateSearch: searchSchema,
	component: CourseManagementPage,
});
